export default {
  "titleFrontEnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["人事資料填寫"])},
  "titleBackEnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["人事資料查詢"])},
  "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關於"])},
  "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登入"])},
  "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登出"])},
  "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帳號"])},
  "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密碼"])},
  "captcha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["驗證碼"])},
  "enterCaptcha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入驗證碼"])},
  "captchaError": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["驗證碼錯誤"])},
  "formSubmitError": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帳/密驗證失敗"])},
  "consentForm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["個人資料使用同意書"])},
  "consentReadAgree": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我已閱讀並同意上述聲明內容"])},
  "consentContinue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意並繼續"])}
}